export const classes = {
  message:
    'w-full px-5 py-12 text-[14px] text-taupe-1 text-center font-normal dark:text-mauve-3',
};
